type NfbWeekday = "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday";

type RawNfbPeriodCapacity = { morning: number; afternoon: number };

type RawNfbBlockedRule = { day: NfbWeekday; time: { start: string; end: string } };

type RawClinicNfbCapacity = {
    week: Partial<Record<NfbWeekday, RawNfbPeriodCapacity>>;
    blocked: Array<RawNfbBlockedRule>;
};

export type ClinicSettings = { NFB_CAPACITY?: RawClinicNfbCapacity };

const NFB_WEEKDAY_LABELS: Record<NfbWeekday, string> = {
    monday: "Seg",
    tuesday: "Ter",
    wednesday: "Qua",
    thursday: "Qui",
    friday: "Sex",
    saturday: "Sáb",
};

export const parseClinicNfbCapacity = (clinicSettings: ClinicSettings | null | undefined) => {
    const rawNfbCapacity = clinicSettings?.NFB_CAPACITY;
    if (!rawNfbCapacity) return null;

    const weekdayCapacities = (Object.keys(NFB_WEEKDAY_LABELS) as Array<NfbWeekday>).map((weekday) => ({
        weekdayLabel: NFB_WEEKDAY_LABELS[weekday],
        morningRooms: rawNfbCapacity.week[weekday]?.morning ?? 0,
        afternoonRooms: rawNfbCapacity.week[weekday]?.afternoon ?? 0,
    }));

    const blockedWindows = rawNfbCapacity.blocked.map((blockedRule) => ({
        weekdayLabel: NFB_WEEKDAY_LABELS[blockedRule.day],
        timeRangeLabel: `${blockedRule.time.start}–${blockedRule.time.end}`,
    }));

    const parsedNfbCapacity = { weekdayCapacities, blockedWindows };
    return parsedNfbCapacity;
};

export type ParsedClinicNfbCapacity = NonNullable<ReturnType<typeof parseClinicNfbCapacity>>;
